import React, { Component } from "react";
import FilterControlPanelV2 from "./FilterControlPanelV2";
import MainPanelContainerV2 from "./MainPanelContainerV2";
import axios from "axios";
import LoadingAnimationV2 from "./LoadingAnimationV2";
import { defaultVaules, creditScoreList, loanPurposeList, ProductTypes } from "./AppData";
import { affiliatesDetail, sorts, creditScorePopup,loanPuposePopup, ajaxEnpoint } from "./LoanOfferListV2";
import { SendEmail } from "./EmailFunctions";
import { validators } from "./Validators";
import HeaderIntroduction from "./HeaderIntroduction";

class LoanCategoryContainerV2 extends Component {
    constructor(props) {
        super(props);
        this.stateZipCode = {
            stateCode: '',
            zipCode: ''
        };
        
        const filteredCreditScore = creditScoreList.filter(lp => {
            if(this.props.creditScore) {
                return (lp.text.toLowerCase() === this.props.creditScore.toLowerCase());
            }
            return filteredCreditScore;
        });
        this.handleLoanPurposeChange = this.handleLoanPurposeChange.bind(this);
        this.handleCreditScoreChange = this.handleCreditScoreChange.bind(this);
        this.handleLenderStateChange = this.handleLenderStateChange.bind(this);
        this.handleLoanAmountChange = this.handleLoanAmountChange.bind(this);
        this.handleIncomeChange = this.handleIncomeChange.bind(this);
        this.handleLoanTermChange = this.handleLoanTermChange.bind(this);
        this.handleUpdateResultClick = this.handleUpdateResultClick.bind(this);
        this.handleZipCodeChange = this.handleZipCodeChange.bind(this);
        this.handleSortByChage = this.handleSortByChage.bind(this);
        this.hideLoder = this.hideLoder.bind(this);
        this.validations = validators();
        this.onSuccessOfGeoLocation = this.onSuccessOfGeoLocation.bind(this);
        this.closeFilters = this.closeFilters.bind(this);
        this.showFilters = this.showFilters.bind(this);
        this.updateGetStartedLink = this.updateGetStartedLink.bind(this);
        // this.handleshowFilters = this.handleshowFilters.bind(this);
        this.state = {
            lenderParams:this.props.lenderParams?this.props.lenderParams:(window[this.props.rootId].lender?window[this.props.rootId].lender:''),
            loanPurpose:this.props.loanPurposeBC?this.props.loanPurposeBC:(window[this.props.rootId].loanPurpose?window[this.props.rootId].loanPurpose:defaultVaules.loanPurpose),
            lenderState:this.props.lenderState?this.props.lenderState:(window.lenderState?window.lenderState:''),
            loanAmount: this.props.loanAmount && !isNaN( this.props.loanAmount) ? Math.ceil( parseInt(this.props.loanAmount, 10)/1000)*1000 :(window[this.props.rootId].loanamount?window[this.props.rootId].loanamount:defaultVaules.loanamount? defaultVaules.loanamount:10000),
            annualIncome: this.props.annualIncome && !isNaN(this.props.annualIncome) ? !this.validations.isAnualIncomeInRange(this.props.annualIncome) ? Math.ceil( parseInt(this.props.annualIncome, 10)/1000)*1000 : 50000 : (window.annualIncome?window.annualIncome:defaultVaules.annualIncome? defaultVaules.annualIncome:50000) ,
            creditScore: filteredCreditScore.length > 0 ? filteredCreditScore[0].key : defaultVaules.creditScore,
            loanTerm: 3,
            isLoading: false,
            zipCode: this.props.zipCode ? this.props.zipCode : '',
            updateResult: false,
            geoBasedZipCode: false,
            //showCreditScorePopup: this.props.creditScore || window[this.props.rootId].credit_score ? false : true,
            showCreditScorePopup: false,
            showLoanPuposePopup: false,
            SortVersion:this.props.SortVersion,
            deviceWidth: document.getElementById("acorn-body") !== null ? document.getElementById("acorn-body").offsetWidth : ( document.getElementById(this.props.rootId) !== null && document.getElementById(this.props.rootId) ? document.getElementById(this.props.rootId).offsetWidth : 0 ),
            offsetWidth : 0,
            displayFiler: false,
            getStartedLink: "",
            sortByValue:"apr_l_h"
        };
        this.filters = {
            loanPurpose: this.state.loanPurpose,
            loanPurposeIndex: this.GetLoanPurposeIndex(this.state.loanPurpose, 3),
            loanAmount: this.state.loanAmount,
            annualIncome: this.state.annualIncome,
            creditScore: this.state.creditScore,
            loanTerm: this.state.loanTerm,
            zipCode: this.state.zipCode,
            isLoading: this.state.isLoading,
            stateCode: '',
            listInjection: [],
            newLenders: []
           
            
        };        
    }
    componentDidMount() {   
        var that = this;
        window.addEventListener("resize", (ev) => {
            var width = document.getElementById("acorn-body") !== null ? document.getElementById("acorn-body") : document.getElementById(this.props.rootId);
            that.setState({ deviceWidth : width.offsetWidth});
        });

        let incomingCS ='';
        if(this.props.creditScore) {
            incomingCS = this.GetCreditscoreKey(this.props.creditScore, 0);
            this.setState({creditScore : incomingCS}) ;
        }
        // if(window[this.props.rootId].credit_score && window[this.props.rootId].credit_score !== '') {
        //     incomingCS = this.GetCreditscoreKey(window[this.props.rootId].credit_score, 0);
        //     this.setState({creditScore : incomingCS}) ;
        //     if(window[this.props.rootId].loanPurpose && window[this.props.rootId].loanPurpose !== '') {
        //         this.setState({loanPurpose : this.GetLoanPurposeIndex(window[this.props.rootId].loanPurpose,0) });
        //     }
        // } else if(this.props.creditScore) {
        //     incomingCS = this.GetCreditscoreKey(this.props.creditScore, 0);
        //     this.setState({creditScore : incomingCS}) ;
        // }
        // if(this.props.loanAmount && !isNaN( this.props.loanAmount)) {
        //     this.setState({ loanAmount : Math.ceil(  parseInt(this.props.loanAmount, 10)/1000)*1000});
        // }
        if( this.props.annualIncome && !isNaN(this.props.annualIncome)){
            this.setState({ annualIncome : !this.validations.isAnualIncomeInRange(this.props.annualIncome) ? Math.ceil( parseInt(this.props.annualIncome, 10)/1000)*1000 : 50000 });
        }
        
        let lenderResult = this.GetLenderByProductType(this.props.lenders);
        this.setState({ newlenderResult: lenderResult});
        // this.setState({ newlenderResult : this.GetSortedLenders(affiliatesDetail,this.props.SortVersion,lenderResult, incomingCS ? incomingCS : this.state.creditScore) });
        if( this.props.creditScore > 0 && this.props.creditScore <5 ) {
            this.setState({ showCreditScorePopup:  false, showLoanPuposePopup: false });
            incomingCS = this.GetCreditscoreKey(this.props.creditScore, 0);
           this.setState({creditScore : incomingCS}) ;
        }
        this.handleUpdateResultClick(this.state.loanPurpose, incomingCS ? incomingCS : this.state.creditScore, this.state.loanAmount, true);
    }
    GetLenderByProductType(lenders) {
        let lenderResult = [];
        lenders.filter((lender) => { 
			if((this.props.pcl === '0' && this.props.hei==='0' && this.props.hel === '0') || this.props.pl === '1'){
                if(lender.productType === ProductTypes.PersonalLoan) lenderResult.push(lender);
			}
			if(this.props.pcl === '1') {
				if(lender.productType ===  ProductTypes.PersonalCreditLine) lenderResult.push(lender);
			}
			if(this.props.hei === '1') {
				if(lender.productType === ProductTypes.HomeEquityInvestment) lenderResult.push(lender);
			}
			if(this.props.hel === '1') {
				if(lender.productType === ProductTypes.HomeEquityLoans) lenderResult.push(lender);
			}
		});
        return lenderResult;
    }
    CreditScoreSetSession(cs){
        try {
            let source = `action=update_credit_score&nonce=4109b2257c&credit_score=${cs}`;
            SendEmail(ajaxEnpoint, source);
        } catch (error) {
            
        }
    }
    LendserStateSetSession(ls){
        try {
            let source = `action=update_lender_state&nonce=4109b2257c&lender_state=${ls}`;
            SendEmail(ajaxEnpoint, source);
        } catch (error) {
            
        }
    }
    LoanPurposeSetSession(lp){
        try {
            let source = `action=update_loan_purpose_acorn&nonce=4109b2257c&loanPurpose=${lp}`;
            SendEmail(ajaxEnpoint, source);
        } catch (error) {
            
        }
    }
    closePopup(event) {
        this.setState({ showCreditScorePopup: false, creditScore: "620-679", showLoanPuposePopup: false, loanPurpose : defaultVaules.loanPurpose});
        this.setState({ newlenderResult: this.props.lenders});
        // this.setState({ newlenderResult : this.GetSortedLenders(affiliatesDetail,this.props.SortVersion,this.props.lenders) });
        this.handleUpdateResultClick(this.filters.loanPurpose, "620-679",this.state.loanAmount, true);
        this.CreditScoreSetSession("620-679");
        this.LoanPurposeSetSession(defaultVaules.loanPurpose);
    }
    creditscorePopoup(event) {
        this.setState({ creditScore: event.target.value });
        if(this.props.versionLP &&  this.props.versionLP !== '' && this.props.versionLP !== "0") {
            this.setState({ showCreditScorePopup: false, showLoanPuposePopup: true, loanPurpose : "Select"});
           
        } else {
            this.setState({ showCreditScorePopup: false, showLoanPuposePopup: false,
                newlenderResult: this.props.lenders});
                // newlenderResult : this.GetSortedLenders(affiliatesDetail,this.props.SortVersion,this.props.lenders, event.target.value)});
            this.handleUpdateResultClick(this.filters.loanPurpose, event.target.value,this.state.loanAmount, true);
        }
        this.CreditScoreSetSession(event.target.value);
        
    }
    loanPuposePopup(event) {
        this.setState({ showCreditScorePopup: false, showLoanPuposePopup: false});
        this.setState({ loanPurpose: event.target.value });
        this.filters.loanPurpose = event.target.value;
        this.filters.loanPurposeIndex = this.GetLoanPurposeIndex(event.target.value, 3);
        this.setState({ newlenderResult: this.props.lenders});
        // this.setState({ newlenderResult : this.GetSortedLenders(affiliatesDetail,this.props.SortVersion,this.props.lenders) });
        this.handleUpdateResultClick(event.target.value,this.state.creditScore,this.state.loanAmount, true);
        this.LoanPurposeSetSession(event.target.value);
    }
    GetCreditscoreName(selectedCreditSore){
        const filteredCreditScore = creditScoreList.filter(lp => {
            if(selectedCreditSore) {
                return (lp.index.toLowerCase() === selectedCreditSore.toLowerCase() || lp.key === selectedCreditSore.toLowerCase() || lp.text === selectedCreditSore.toLowerCase());
            }
            return filteredCreditScore;
        });
        if(filteredCreditScore.length > 0) {
            return filteredCreditScore[0].text.toLowerCase();
        } else {
            return '';
        }
    }
    GetCreditscoreKey(selectedCreditSore, index){
        const filteredCreditScore = creditScoreList.filter(lp => {
            if(selectedCreditSore) {
                return (lp.index.toLowerCase() === selectedCreditSore.toLowerCase() || lp.key.toLowerCase() === selectedCreditSore.toLowerCase() || lp.text.toLowerCase() === selectedCreditSore.toLowerCase());
            }
            return filteredCreditScore;
        });
        if(filteredCreditScore.length > 0) {
            if(index === 0) {
                return filteredCreditScore[0].key.toLowerCase();
            } else if (index === 1) {
                return filteredCreditScore[0].text.toLowerCase();
            } else if (index === 2)  {
                return filteredCreditScore[0].label.toLowerCase();
             }  else if (index === 3) {
                return filteredCreditScore[0].index;
             }
           
        } else {
            return '';
        }
    }
    GetLoanPurposeIndex(selectedLoanPupose, index){
        const filteredLoanPupose = loanPurposeList.filter(lp => {
            if(selectedLoanPupose) {
                // console.log(lp.key.toLowerCase() === selectedLoanPupose.toLowerCase() , lp.key.toLowerCase() , selectedLoanPupose.toLowerCase());
                return (lp.index.toLowerCase() === selectedLoanPupose.toLowerCase() || lp.key.toLowerCase() === selectedLoanPupose.toLowerCase() || lp.text.toLowerCase() === selectedLoanPupose.toLowerCase());
            }
            return filteredLoanPupose;
        });
        // console.log(filteredLoanPupose, loanPurposeList, selectedLoanPupose);
        if(filteredLoanPupose.length > 0) {
            if(index === 0) {
                return filteredLoanPupose[0].key;
            } else if (index === 1) {
                return filteredLoanPupose[0].text;
            } else if (index === 2)  {
                return filteredLoanPupose[0].label;
             }  else if (index === 3) {
                return filteredLoanPupose[0].index;
             }
           
        } else {
            return '';
        }
    }
    GetSortedLenders(affiliatesDetail,sortVersion,lenderResult,  creditScore = this.state.creditScore) {
        let newlenderResult;
               //Find Affiliated 
            const selectedAffiliated = affiliatesDetail.filter(element => {
                if(element.AFID) {
                    return parseInt(element.AFID, 10) === parseInt(this.props.AffiliateId, 10);
                } else { return null; }
            }); 
            //Affiliated Found
            if(selectedAffiliated.length > 0) {
                //Filter by selected SortVersion
                let selectedSort = selectedAffiliated[0].sortVersions.filter(element => {
                    if(this.props.SortVersion) {
                        return  parseInt(element.sortVersionID, 10) === parseInt(this.props.SortVersion, 10);
                    } else { return null; }
                });
                //SortVersion Found
                if(selectedSort && selectedSort.length > 0) {
                    this.setState({ SortVersion: selectedSort[0].sortVersionID});
                    let selectedSortId = sorts.filter(element => {
                        return true;
                        // return parseInt(element.sortID, 10) === parseInt(selectedSort[0].creditScoreSortId[this.GetCreditscoreName(creditScore)], 10);
                    });
                    if(selectedSortId && selectedSortId.length > 0) {
                        newlenderResult=this.sortedLenderResult(lenderResult, selectedSortId[0].sortOrder, selectedSortId[0].listInjection);
                    }
                }else {  //SortVersion Not Found 
                    let sortVersions = selectedAffiliated[0].sortVersions.filter(element => {
                        return parseInt(element.sortVersionID, 10) === 0; // Take Default SortVersion from Affilieated
                    });
                    // Get SortId from Selected Credit Score
                    let selectedSort = this.props.Sorts.filter(element => {
                        return true;
                        // return parseInt(element.sortID, 10) === parseInt(sortVersions[0].creditScoreSortId[this.GetCreditscoreName(creditScore)], 10);
                    });
                    this.setState({ SortVersion : 0 });
                    if(selectedSort && selectedSort.length > 0) {
                        newlenderResult=this.sortedLenderResult(lenderResult, selectedSort[0].sortOrder, selectedSort[0].listInjection);
                    }
                }
            } else {  //Affiliated Not Found , look for default
                const defaultAffiliated = affiliatesDetail.filter(element => {
                    if(element.AFID) {
                        return element.AFID === 'default';
                    } else { return null; }
                }); 
                let selectedSort = defaultAffiliated[0].sortVersions.filter(element => {
                    if(this.props.SortVersion) {
                        return  parseInt(element.sortVersionID, 10) === parseInt(this.props.SortVersion, 10);
                    } else { return null; }
                });
                if(selectedSort && selectedSort.length > 0) {
                    this.setState({ SortVersion: selectedSort[0].sortVersionID});
                    let selectedSortId = sorts.filter(element => {
                        return true;
                        // return parseInt(element.sortID, 10) === parseInt(selectedSort[0].creditScoreSortId[this.GetCreditscoreName(creditScore)], 10);
                    });
                    newlenderResult=this.sortedLenderResult(lenderResult, selectedSortId[0].sortOrder, selectedSortId[0].listInjection);
                } else {
                    let sortVersions = defaultAffiliated[0].sortVersions.filter(element => {
                        return parseInt(element.sortVersionID, 10) === 0; // Take Default SortVersion from Affilieated
                    });
                    this.setState({ SortVersion : 0 });
                    let selectedSortId = sorts.filter(element => {
                        return true;
                        // return parseInt(element.sortID, 10) === parseInt(sortVersions[0].creditScoreSortId[this.GetCreditscoreName(creditScore)], 10);
                    });
                     
                    if(selectedSortId && selectedSortId.length > 0) {
                        newlenderResult=this.sortedLenderResult(lenderResult, selectedSortId[0].sortOrder, selectedSortId[0].listInjection);
                    }
                }
            }
        return newlenderResult;
    }
    sortedLenderResult(lenderResult, selectedSort, selectedlistInjection) {
        var newLenders = [];
        this.setState({  listInjection: selectedlistInjection });
        lenderResult.forEach(function(element) {   
            var sortIndex =  selectedSort.indexOf(parseInt(element.partnerId, 10));
                if(sortIndex >= 0 ) {
                    element.sortIndex = sortIndex;
                    newLenders.push(element);
                }    
          });   
        var primeratesDetail = lenderResult.filter(element => {
                return element.lenderId === 'primerates';
            });
            newLenders.push(primeratesDetail[0]);
        return newLenders;
    }
    getSortIndexByPartnerId(partnerId, sortIndex) {
        let index = sortIndex.indexOf(parseInt(partnerId, 10));
        return index;
    }
    getCityState(zipCode) {
        return axios.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + zipCode
            + '&key=AIzaSyB2f5Jni7QtJqie3POgTO5L3grbeatalWo&type=json');
    }

    getZipcodeStateCodeByGeoLocation(lat, long) {
        return axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + long
            + '&key=AIzaSyB2f5Jni7QtJqie3POgTO5L3grbeatalWo&type=json');
    }

    hideLoder() {
        this.filters.isLoading = false;
        this.setState({ isLoading: false });
    }

    onSuccessOfGeoLocation(pos) {
        const crd = pos.coords;
        var promise = this.getZipcodeStateCodeByGeoLocation(crd.latitude, crd.longitude);
        promise.then(response => {
            //find the city and state            
            let address_components = response.data.results[0].address_components;
            if (address_components !== undefined) {
                address_components.forEach(address => {

                    if (address.types.indexOf('administrative_area_level_1') >= 0) {
                        this.stateZipCode.stateCode = address.short_name;
                    }

                    if (address.types.indexOf('postal_code') >= 0) {
                        this.stateZipCode.zipCode = address.short_name;
                    }
                });

                this.setState({ stateCode: this.stateZipCode.stateCode, zipCode: this.stateZipCode.zipCode });
                this.handleUpdateResultClick(this.filters.loanPurpose, this.filters.creditScore,this.state.loanAmount, true);
            }
        });
    };

    handleZipCodeChange(zipCode, isUpdateResult, stateCode) {
        this.setState({ zipCode: zipCode });
        if (zipCode.length === 5) {

            if (isUpdateResult) {
                // if zipcode determined by geo location then update result
                this.stateZipCode.zipCode = zipCode;
                this.stateZipCode.stateCode = stateCode;
                this.handleUpdateResultClick(this.filters.loanPurpose, this.filters.creditScore,this.state.loanAmount, true);
            }
            else {
                // Determine state code from zip code
                var promise = this.getCityState(zipCode);
                promise.then(response => {

                    //find the city and state            
                    let address_components = response.data.results[0].address_components;
                    if (address_components !== undefined) {
                        address_components.forEach(address => {
                            if (address.types.indexOf('administrative_area_level_1') === -1) {
                                return;
                            }
                            this.stateZipCode.zipCode = zipCode;
                            this.stateZipCode.stateCode = address.short_name;
                        });
                    }
                });
            }
        }
    }

    handleSortByChage(sortByValue) {
        this.setState({sortByValue:sortByValue});
        this.handleUpdateResultClick(this.filters.loanPurpose, this.filters.creditScore,this.state.loanAmount, true);
    }

    handleUpdateResultClick(loanPurpose, creditScore,loanAmount, isSubmitted,lenderState='') {
        
        this.filters.loanAmount = typeof loanAmount === typeof undefined ? this.state.loanAmount : loanAmount;
        this.filters.loanPurpose = typeof loanPurpose === typeof undefined ? this.state.loanPurpose : loanPurpose;

        if(isSubmitted) {

            this.setState({ loanPurpose: loanPurpose, creditScore: creditScore });
            this.filters.annualIncome = this.state.annualIncome;
            this.filters.creditScore = typeof creditScore === typeof undefined ? this.state.creditScore : creditScore;;
            
            this.filters.loanTerm = this.state.loanTerm;
            this.filters.zipCode = this.stateZipCode.zipCode;
            this.filters.stateCode = this.stateZipCode.stateCode;
            this.filters.isLoading = true;
            this.setState({ updateResult: true, isLoading: true });

            setTimeout(function () {
                this.hideLoder();
            }.bind(this), 500);
        }
    }

    handleLoanTermChange(loanTerm, isUpdateResult) {
        this.setState({ loanTerm: loanTerm });
        if (isUpdateResult) {
            this.handleUpdateResultClick(this.filters.loanPurpose, this.filters.creditScore,this.state.loanAmount, true);
        }
    }

    handleIncomeChange(annualIncome, isUpdateResult) {
        this.setState({ annualIncome: annualIncome });
        this.handleUpdateResultClick(this.filters.loanPurpose, this.filters.creditScore,undefined, false);
        if (isUpdateResult) {
            this.handleUpdateResultClick(this.filters.loanPurpose, this.filters.creditScore,undefined, true);
        }
    }

    handleLoanAmountChange(loanAmount, isUpdateResult) {
        this.setState({ loanAmount: loanAmount });
        this.handleUpdateResultClick(this.filters.loanPurpose, this.filters.creditScore,loanAmount, false);
        if (isUpdateResult) {
            this.handleUpdateResultClick(this.filters.loanPurpose, this.filters.creditScore,loanAmount, true);
        }
    }

    handleLoanPurposeChange(loanPurpose, isSubmitted) {
        this.setState({ loanPurpose: loanPurpose });
        this.filters.loanPurpose = loanPurpose;
        // this.LoanPurposeSetSession(loanPurpose);
        this.handleUpdateResultClick(loanPurpose, this.filters.creditScore,this.state.loanAmount, true);
    }

    handleLenderStateChange(lenderState, isSubmitted) {
        this.setState({ lenderState: lenderState });
      ///  this.LenderStateSetSession(lenderState);
        this.handleUpdateResultClick(this.filters.loanPurpose, this.filters.creditScore,this.state.loanAmount, true,lenderState);
    }

    handleCreditScoreChange(creditScore, isSubmitted) {
    
        this.setState({ creditScore: creditScore });
        // this.CreditScoreSetSession(creditScore);
        // this.setState({ newlenderResult: this.props.lenders});
        // this.setState({ newlenderResult : this.GetSortedLenders(affiliatesDetail,this.props.SortVersion,this.props.lenders, creditScore) });
        this.handleUpdateResultClick(this.filters.loanPurpose, creditScore,this.state.loanAmount, true);
    }
 showFilters() {
        if(this.props.iframeVersion) {
            try {
                window.parent.postMessage('ScrollToTop', `${window.iframeHost}`);
            } catch (error) {
                console.log(error);
            }
        } else {
            // window.scroll(0, 0);
        }

        this.setState({displayFiler: true});
       
        
        // this.props.handleshowFilters();
    }
    closeFilters(){
        this.setState({displayFiler: false});
    }
    updateGetStartedLink(link){ 
        // if(this.state.getStartedLink !== link) {
            this.setState({getStartedLink: link});
        // }
    }

    createMainPanelContainer() {
        
        return <MainPanelContainerV2
                readOnly={this.props.readOnly}
                isLoading={this.filters.isLoading}
                lenders={this.state.newlenderResult}
                lenderParams={this.state.lenderParams}
                lenderState={this.state.lenderState}
                showSingleLender={this.props.showSingleLender}
                loanPurpose={this.filters.loanPurpose}
                annualIncome={this.filters.annualIncome}
                loanAmount={this.filters.loanAmount}
                creditScore={this.filters.creditScore}
                loanTerm={this.filters.loanTerm}
                stateCode={this.filters.stateCode}
                currentDevice={this.props.currentDevice}
                listInjection={this.state.listInjection}
                IncomingCreditScore={this.props.creditScore}
                currentBrowser={this.props.currentBrowser}
                SID7={this.props.SID7}
                SID8={this.props.SID8}
                SID9={this.props.SID9}
                SID10={this.props.SID10}
                SortVersion={this.state.SortVersion}
                versionLP={this.props.versionLP}
                AffiliateId={this.props.AffiliateId}
                loanAmountBC={this.props.loanAmountBC}   loanPurposeBC={this.props.loanPurposeBC}
                partnerid={this.props.partnerid} gclid={this.props.gclid} featured={this.props.featured}
                programid={this.props.programid} campaignid={this.props.campaignid} utmSource={this.props.utmSource}
                utmMedium={this.props.utmMedium} utmTerm={this.props.utmTerm} utmCampaign={this.props.utmCampaign}
                utmContent={this.props.utmContent} dealerid={this.props.dealerid} version={this.props.version}
                rootId={this.props.rootId}
                showFilters = {this.showFilters}
                updateGetStartedLink ={this.updateGetStartedLink}
                getStartedLink={this.state.getStartedLink}
                deviceWidth={this.state.deviceWidth}
                sortByValue={this.state.sortByValue}
                toggleImage={this.props.toggleImage}
                />
        

    }

    render() {
        let mainPanelContainer = this.state.displayFiler === false ? this.createMainPanelContainer() : '';
        return (

            <div className="personal-loans clearfix loader-min-height">
                {/* {this.state.deviceWidth>1024 &&
                    <LoadingAnimationV2 isLoading={this.filters.isLoading} deviceWidth={this.state.deviceWidth} />
                } */}
            
                <div className="container">
                <HeaderIntroduction 
                 getStartedLink={this.state.getStartedLink}
                 showSingleLender={this.props.showSingleLender}
                 deviceWidth={this.state.deviceWidth}
                />
                    {/* // handleshowFilters={this.handleshowFilters} 
                // getStartedlink={this.updateGetStartedLink()} 
                /> */}
                    {/* // lender={lenderDetail}
                    // loanAmount={loanAmount}                    
                    // loanPurpose={this.GetLoanPurposeIndex(this.props.loanPurpose,3)}
                    // applyLink={lenderDetail.apply.link}
                    // ctaBtnLink={this.GenerateApplyLink()} */}
                      
                     {/* Desktop 
                     { this.state.deviceWidth > 1024  && ( !this.props.readOnly || this.props.readOnly !== true) && this.props.showSingleLender !== true && <div className={` lenderinfoV2 lender-listing cta-btn desktop-down`}>
                        <a href><b className={` cta-button desktop`}>{ctaText}</b></a> 
                    </div> } */}
                 
                    <div className={this.state.displayFiler !== false  ? "row filterbg" : "row desktopbg"}>   
                        <div className="" id="mobile-width" >
                            
                            <FilterControlPanelV2
                                loanPurpose={this.state.loanPurpose}
                                deviceWidth={this.state.deviceWidth}
                                lenderState={this.state.lenderState}
                                loanAmount={this.state.loanAmount}
                                annualIncome={this.state.annualIncome}
                                rootId={this.props.rootId}
                                creditScore={this.state.creditScore}
                                loanTerm={this.state.loanTerm}
                                zipCode={this.state.zipCode ? this.state.zipCode : ''}
                                onLoanPurposeChange={this.handleLoanPurposeChange}
                                onLenderStateChange={this.handleLenderStateChange}
                                onLoanAmountChange={this.handleLoanAmountChange}
                                onCreditScoreChange={this.handleCreditScoreChange}
                                onIncomeChange={this.handleIncomeChange}
                                onLoanTermChange={this.handleLoanTermChange}
                                onUpdateResultClick={this.handleUpdateResultClick}
                                onZipCodeChange={this.handleZipCodeChange}
                                isGeoBasedZipCode={this.state.geoBasedZipCode} 
                                currentDevice={this.props.currentDevice}
                                creditScoreIndex={this.props.creditScore}
                                versionLP={this.props.versionLP}
                                showFilters={this.state.displayFiler}
                                closeFilters={this.closeFilters}
                                onSortByChage={this.handleSortByChage} 
                                sortByValue={this.state.sortByValue}
                                />
                               
                                {  

                                    mainPanelContainer
                                }
                            
                        </div>
                        { this.state.showCreditScorePopup &&
                            <div id="popupModal" className={`modal ${this.state.showCreditScorePopup ? 'displayblock':''}`}>
                                <div className="modal-content">
                                    <div className="trans-wrap state address-popup">
                                        <button value="close" id={`close`} name={`close`} className="close" onClick={this.closePopup.bind(this)} ><b>x</b></button>
                                        <div className="trans-statment">                                                                    
                                            <h4>{creditScorePopup.title}</h4>
                                            <p>{creditScorePopup.description}</p>
                                        </div>
                                        <button value="720-850" id={`Excellent`} name={`Excellent`} className="btn btn-primary" onClick={this.creditscorePopoup.bind(this)} > Excellent <br /> (720-850)</button>
                                        <button value="680-719" id={`Good`} name={`Good`} className="btn btn-primary" onClick={this.creditscorePopoup.bind(this)} > Good <br /> (680-719)</button>
                                        <button value="620-679" id={`Average`} name={`Average`} className="btn btn-primary" onClick={this.creditscorePopoup.bind(this)} > Average <br /> (620-679)</button>
                                        <button value="350-619" id={`Poor`} name={`Poor`} className="btn btn-primary" onClick={this.creditscorePopoup.bind(this)} > Poor <br /> (below 620)</button>
                                    </div> 
                                </div>
                            </div>
                        }
                        { this.state.showLoanPuposePopup &&
                            <div id="popupModal" className={`modal ${this.state.showLoanPuposePopup ? 'displayblock':''}`}>
                                <div className="modal-content  modal-content-height">
                                    <div className="trans-wrap state address-popup">
                                        <button value="close" id={`close`} name={`close`} className="close" onClick={this.closePopup.bind(this)} ><b>x</b></button>
                                        <div className="trans-statment">                                                                    
                                            <h4>{loanPuposePopup.title}</h4>
                                        </div>
                                        <div className={`col-sm-12 leftpanel box-panelV2 loanpurpose_center`}>
                                            <div className="form-group clearfix">
                                            
                                                <select  className= {`loan-app form-control form-group `}
                                                value={this.state.loanPurpose}
                                                onChange={this.loanPuposePopup.bind(this)}
                                                id={`loanpurpose`} name={`loanpurpose`}
                                            >
                                            <option key="Select" rel="0"
                                                            value="Select" id="Select" name="Select">
                                                            Please select ...
                                                        </option>
                                            {loanPurposeList.map(element => {
                                                        return <option key={element.key} rel={element.index}
                                                            value={element.key} id={element.key} name={element.key}>
                                                            {element.label}
                                                        </option>
                                                    })}

                                            </select>                     
                                            
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        }
                    </div>
                </div>

            </div>
        );
    }
}

export default LoanCategoryContainerV2;


// WEBPACK FOOTER //
// ./src/LoanCategoryContainerV2.js